module.exports = __webpack_public_path__ + "static/media/bell-ring.2c26bb0d.wav";